import React from 'react';
import { PropTypes } from 'prop-types';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import DateFormatter from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/Date';

const LeakDateCell = ({ rowInfo, showSkeleton }) => {
  const label = get(rowInfo, 'original.value.leak_date', '');

  if (showSkeleton) return <Skeleton />;
  if (!label) return null;
  return (
    <DateFormatter date={ label } midDate />
  );
};

LeakDateCell.propTypes = {
  rowInfo: PropTypes.object.isRequired,
  showSkeleton: PropTypes.bool
};

LeakDateCell.defaultProps = {
  showSkeleton: false
};

export default LeakDateCell;
